import React, { Component } from "react";
import ProfileCard from "cardcomponents/ProfileCard";
import UpdatePasswordModal from "modals/UpdatePasswordModal";
class AdminDAccount extends Component {
  idmodal_update_password = "modal_update_password";

  getContent = () => {
    // @ts-ignore
    return <ProfileCard idmodal_update_password={this.idmodal_update_password} />
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            {this.getContent()}
          </div>
        </div>

        <UpdatePasswordModal modal_id={this.idmodal_update_password} />
      </>
    );
  }
}

export default AdminDAccount;
